<app-side-menu>
  <div class="fr-hub-container">
    <div class="row mb-4">
      <div class="col-12">
        <h1 class="page-title">
          <i class="fas fa-chart-pie me-3"></i>
          Relatórios financeiros
        </h1>
        <p class="page-subtitle">
          Cada item abaixo usa um <strong>endpoint próprio</strong> da API de relatórios.
          O <a routerLink="/financial/cashflow">espelho financeiro</a> é outra funcionalidade (visão CR/CP), sem este endpoint.
        </p>
      </div>
    </div>

    <div class="row g-3">
      <div class="col-md-6 col-lg-4" *ngFor="let r of reports">
        <a [routerLink]="r.route" class="fr-report-card">
          <div class="fr-report-card-icon">
            <i [class]="r.icon"></i>
          </div>
          <h2 class="fr-report-card-title">{{ r.title }}</h2>
          <p class="fr-report-card-desc">{{ r.description }}</p>
          <span class="fr-report-card-cta">
            Abrir relatório
            <i class="fas fa-arrow-right ms-2"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</app-side-menu>
